import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getValueFromResource, setItemStatus } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import { GetAccountGeoFenceZone, updatePagination } from './GeofencingSlice';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { ShowToast } from '../../../common/Toastr';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { getPagePermissions } from '../../dashboard/dashboardSlice';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import CustomPagination from "../../../common/Pagination";
import PageSizeSelect from '../../../common/PageSizeSelect';

const GeofenceZoneList = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isLoading, zoneList, totalItems, pageNo, pageSize, startRec } = useAppSelector((state) => state.geofencing);
    const navigate = useNavigate();
    const [permissions, setPermissions] = useState({
        IsList: false,
        IsAdd: false,
        IsEdit: false,
        IsDelete: false,
    });
    const resetToFirstPage = useCallback((size: number) => {
        dispatch(updatePagination({
            startRec: 0,
            pageSize: size,
            pageNo: 1,
        }));
        // dispatch(GetAccountGeoFenceZone({ pageNumber: 1, pageSize: size }));
    }, [dispatch]);

    const handlePageChange = useCallback((page: number) => {
        dispatch(updatePagination({
            startRec: (page - 1) * Number(pageSize),
            pageSize: pageSize,
            pageNo: page,
        }));
        // dispatch(GetAccountGeoFenceZone({ pageNumber: page, pageSize: pageSize }));
    }, [dispatch, pageSize]);

    const handlePageSizeChange = useCallback((event: any) => {
        const { value } = event;
        resetToFirstPage(Number(value));
    }, [resetToFirstPage]);

    const getPermission = async () => {
        try {
            const res = await dispatch(getPagePermissions(513));
            if (res.meta?.requestStatus === 'fulfilled') {
                if (!res?.payload?.IsList) {
                    navigate('../error/403');
                    return;
                }
                setPermissions({
                    IsList: res?.payload?.IsList ?? false,
                    IsAdd: res?.payload?.IsAdd ?? false,
                    IsEdit: res?.payload?.IsEdit ?? false,
                    IsDelete: res?.payload?.IsDelete ?? false,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getPermission();
        dispatch(GetAccountGeoFenceZone({ pageNumber: pageNo, pageSize: pageSize }));
    }, [pageNo, pageSize])

    const handleDeletZone = async (id: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then(async (result) => {
                if (result) {
                    try {
                        const response = await fetchTimeliveAPI(`api/GeoFenceZone/DeleteAccountGeoFenceZone/${id}`, `DELETE`, '', true);
                        const json = await response.json();
                        if (json?.StatusCode === '200') {
                            ShowToast('Success', json.ResponseMessage, 'success', "toast-top-right");
                            dispatch(GetAccountGeoFenceZone({ pageNumber: pageNo, pageSize: pageSize }))
                        } else {
                            ShowToast('error', json.ResponseMessage, "error", "toast-top-right")
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            })
    }
    return (
        <div>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading d-flex align-items-center gap-1">
                        {getValueFromResource('Zone List', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-description"
                            data-tooltip-content={getValueFromResource('Create and manage geofence zones by selecting a location on the map, defining a radius, and saving the corresponding address. These zones are later used for validating employee location during attendance actions.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="card-toolbar align-items-center">
                            <div className="d-flex align-items-center">
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div>
                                {(totalItems > 0) ? (
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={startRec}
                                        t={t}
                                    >
                                    </CustomPagination>
                                ) : null}
                            </div>
                        </div>
                        {permissions?.IsAdd &&
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <button type="button"
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                    style={{ marginRight: '2px', display: 'block' }}
                                    onClick={() => navigate('/geofencing')}
                                >
                                    {getValueFromResource('Add Zone', dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th style={{ width: '15%' }}> {getValueFromResource('Active / Inactive', dispatch, t)}</th>
                                    <th style={{ width: '30%' }}>{getValueFromResource('Zone Name', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('Zone Code', dispatch, t)}</th>
                                    <th style={{ width: '10%' }}>{getValueFromResource('Boundary Type', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('State', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('Country', dispatch, t)}</th>
                                    <th className='w-10 text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {zoneList?.length > 0 && zoneList?.map((item: any) => {
                                    return (
                                        <tr>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled ? "InActive" : "Active"))}>
                                                    {item.IsDisabled ? "InActive" : "Active"}
                                                </span>
                                            </td>
                                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '>
                                                <span onClick={() => navigate(`/geofencing/${item?.AccountGeoFenceZoneId}/edit?from=zonelist`)} className="d-block ">{item?.ZoneName}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block ">{item?.ZoneCode}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block ">{item?.BoundaryName}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block ">{item?.State}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block ">{item?.Country}</span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {permissions?.IsEdit && <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigate(`/geofencing/${item?.AccountGeoFenceZoneId}/edit?from=zonelist`)}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>}
                                                        {/* <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => handleDeletZone(item?.AccountGeoFenceZoneId)}
                                                            >
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {getValueFromResource('Delete', dispatch, t)}

                                                                </span>
                                                            </Dropdown.Item>
                                                        </div> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default GeofenceZoneList